import React from "react";
import TrackingSystemLanding from "../../components/tracking-system/TrackingSystemLanding";
import { useSelector } from "react-redux";
import { selectAuth } from "../../components/auth/auth.selector";

const TrackingSystem = () => {
  const authData = useSelector(selectAuth);
  const userInfoData = authData?.user || {};

  return (
    <div>
      <TrackingSystemLanding userInfoData={userInfoData} />
    </div>
  );
};

export default TrackingSystem;
